import { createContext, useContext, RefObject } from "react"
import { FormikProps } from "formik"
import { Integration } from "../../../types"

interface IntegrationContextValue {
  formIntegrationRef: RefObject<FormikProps<Integration>> | null
}

export const IntegrationContext = createContext<IntegrationContextValue>({
  formIntegrationRef: null
})

export const useFormIntegrationRef = () => {
  const { formIntegrationRef } = useContext(IntegrationContext)
  return formIntegrationRef
}
